import React from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var ANIMATE_CC_ERROR_NAME = 'AnimateCC';
var AnimateCCError = /** @class */ (function (_super) {
    __extends(AnimateCCError, _super);
    function AnimateCCError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ANIMATE_CC_ERROR_NAME;
        return _this;
    }
    return AnimateCCError;
}(Error));

var AdobeAn = global.AdobeAn;
if (typeof window !== 'undefined' && AdobeAn === undefined) {
    throw new AnimateCCError('AdobeAn dependency not found');
}

var CreateJS = global.createjs;
if (typeof window !== 'undefined' && CreateJS === undefined) {
    throw new AnimateCCError('createjs dependency not found');
}

var hexToRgba = function (color, opacity) {
    var r = parseInt(color.substring(1, 3), 16);
    var g = parseInt(color.substring(3, 5), 16);
    var b = parseInt(color.substring(5, 7), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
};

var getCompositionId = function (searchedName, composition) {
    var compositionIds = Object.keys(AdobeAn.compositions);
    if (composition) {
        if (AdobeAn.compositions[composition].getLibrary()[searchedName]) {
            return composition;
        }
        return null;
    }
    var foundComposition = compositionIds.filter(function (id) {
        var library = AdobeAn.compositions[id].getLibrary();
        var props = Object.keys(library);
        var independent = props.filter(function (prop) {
            var _a, _b;
            if (((_b = (_a = library === null || library === void 0 ? void 0 : library[prop]) === null || _a === void 0 ? void 0 : _a.prototype) === null || _b === void 0 ? void 0 : _b.mode) === 'independent') {
                return true;
            }
            return false;
        });
        return independent.some(function (name) { return name === searchedName; });
    })[0];
    return foundComposition;
};

var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // eslint-disable-next-line no-console
    console.error.apply(console, __spreadArrays(['AnimateCC:'], args));
};

var AnimateCC = /** @class */ (function (_super) {
    __extends(AnimateCC, _super);
    function AnimateCC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvasRef = React.createRef();
        _this.state = {
            error: false,
        };
        _this.onAnimationReady = function () {
            _this.resizeCanvas();
            _this.startAnimation();
        };
        _this.handleFileError = function (evt) {
            if (evt.title === 'FILE_LOAD_ERROR') {
                var src = evt.data.src;
                log("Asset " + src + " failed to load");
                _this.setState({ error: true });
            }
        };
        _this.handleComplete = function (evt, composition) {
            var error = _this.state.error;
            if (error) {
                return;
            }
            var _a = _this.props, animationName = _a.animationName, paused = _a.paused, getAnimationObject = _a.getAnimationObject;
            var lib = composition.getLibrary();
            if (evt !== null) {
                var ss = composition.getSpriteSheet();
                var queue = evt.target;
                var _b = lib.ssMetadata, ssMetadata = _b === void 0 ? [] : _b;
                for (var _i = 0, ssMetadata_1 = ssMetadata; _i < ssMetadata_1.length; _i++) {
                    var metadata = ssMetadata_1[_i];
                    if (metadata) {
                        ss[metadata.name] = new CreateJS.SpriteSheet({
                            images: [queue === null || queue === void 0 ? void 0 : queue.getResult(metadata.name)],
                            frames: metadata.frames,
                        });
                    }
                }
            }
            var animationObject = new lib[animationName]();
            getAnimationObject === null || getAnimationObject === void 0 ? void 0 : getAnimationObject(animationObject);
            _this.animationObject = animationObject;
            _this.animationObject.tickEnabled = !paused;
            if (_this.canvasRef.current) {
                _this.stage = new lib.Stage(_this.canvasRef.current);
                _this.setState({ properties: lib.properties }, _this.onAnimationReady);
            }
        };
        _this.handleFileLoad = function (evt, comp) {
            var _a;
            var images = comp.getImages();
            if (((_a = evt === null || evt === void 0 ? void 0 : evt.item) === null || _a === void 0 ? void 0 : _a.type) === 'image') {
                images[evt.item.id] = evt.result;
            }
        };
        // Registers the "tick" event listener.
        _this.startAnimation = function () {
            var _a;
            var properties = _this.state.properties;
            if (properties !== undefined) {
                AdobeAn.compositionLoaded(properties.id);
            }
            if (_this.animationObject !== undefined) {
                (_a = _this.stage) === null || _a === void 0 ? void 0 : _a.addChild(_this.animationObject);
            }
            if (properties !== undefined && _this.stage !== undefined) {
                CreateJS.Ticker.framerate = properties.fps;
                CreateJS.Ticker.addEventListener('tick', _this.stage);
            }
        };
        // Unregisters the "tick" event listener.
        _this.stopAnimation = function () {
            if (_this.stage !== undefined) {
                CreateJS.Ticker.removeEventListener('tick', _this.stage);
            }
        };
        _this.getCanvasSize = function () {
            var _a, _b;
            var properties = _this.state.properties;
            var width = (_a = properties === null || properties === void 0 ? void 0 : properties.width) !== null && _a !== void 0 ? _a : 1;
            var height = (_b = properties === null || properties === void 0 ? void 0 : properties.height) !== null && _b !== void 0 ? _b : 1;
            var pRatio = window.devicePixelRatio;
            return {
                width: width * pRatio,
                height: height * pRatio,
            };
        };
        // Code to support hidpi screens and responsive scaling.
        _this.resizeCanvas = function () {
            var pRatio = window.devicePixelRatio;
            if (_this.stage !== undefined) {
                _this.stage.scaleX = pRatio;
                _this.stage.scaleY = pRatio;
                _this.stage.tickOnUpdate = false;
                _this.stage.update();
                _this.stage.tickOnUpdate = true;
            }
        };
        return _this;
    }
    AnimateCC.prototype.componentDidMount = function () {
        var _this = this;
        if (typeof window === 'undefined') {
            return;
        }
        var _a = this.props, animationName = _a.animationName, externalCompositionId = _a.composition;
        var compositionId = getCompositionId(animationName, externalCompositionId);
        if (compositionId === null) {
            log(externalCompositionId + " composition was not found in " + animationName + " animation");
            this.setState({ error: true });
            return;
        }
        var composition = AdobeAn.getComposition(compositionId);
        if (composition === undefined) {
            log("Animation with name " + animationName + " was not found");
            this.setState({ error: true });
            return;
        }
        var manifest = composition.getLibrary().properties.manifest;
        var loader = new CreateJS.LoadQueue(false);
        loader.addEventListener('fileload', function (evt) { _this.handleFileLoad(evt, composition); });
        loader.addEventListener('complete', function (evt) { _this.handleComplete(evt, composition); });
        loader.addEventListener('error', function (evt) { _this.handleFileError(evt); });
        loader.loadManifest(manifest);
        if (manifest.filter(function (_a) {
            var type = _a.type;
            return type === 'image';
        }).length === 0) {
            this.handleComplete(null, composition);
        }
    };
    AnimateCC.prototype.componentDidUpdate = function () {
        var error = this.state.error;
        var paused = this.props.paused;
        if (!error && this.animationObject !== undefined) {
            this.animationObject.tickEnabled = !paused;
        }
    };
    AnimateCC.prototype.componentWillUnmount = function () {
        var error = this.state.error;
        if (error) {
            return;
        }
        // Force garbage collection on Safari
        // https://bugs.webkit.org/show_bug.cgi?id=195325
        if (this.canvasRef.current) {
            this.canvasRef.current.height = 0;
            this.canvasRef.current.width = 0;
        }
        this.stopAnimation();
    };
    AnimateCC.prototype.render = function () {
        var _a = this.props, animationName = _a.animationName, getAnimationObject = _a.getAnimationObject, paused = _a.paused, additionalStyles = _a.style, composition = _a.composition, props = __rest(_a, ["animationName", "getAnimationObject", "paused", "style", "composition"]);
        if (typeof window === 'undefined') {
            return null;
        }
        var properties = this.state.properties;
        var _b = this.getCanvasSize(), canvasWidth = _b.width, canvasHeight = _b.height;
        if (properties === undefined || Object.keys(properties).length === 0) {
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("canvas", { ref: this.canvasRef }),
                    React.createElement("div", null))));
        }
        var color = hexToRgba(properties.color, properties.opacity);
        return (React.createElement("div", null,
            React.createElement("div", __assign({ style: __assign({ width: '100%', height: '100%' }, additionalStyles) }, props),
                React.createElement("canvas", { ref: this.canvasRef, width: canvasWidth, height: canvasHeight, style: {
                        display: 'block',
                        width: '100%',
                        backgroundColor: color,
                    } }),
                React.createElement("div", { style: {
                        pointerEvents: 'none',
                        overflow: 'hidden',
                        width: properties.width + "px",
                        height: properties.height + "px",
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        display: 'block',
                    } }))));
    };
    return AnimateCC;
}(React.Component));

export default AnimateCC;
//# sourceMappingURL=index.es.js.map
